var RtRequerimento = /** @class */ (function () {
    function RtRequerimento() {
    }
    return RtRequerimento;
}());
export { RtRequerimento };
